import { isParticipantUser } from 'common-data-handling';
import { useEventParticipants } from '../../../../../../data/hooks/participant/useEventParticipants';
import { useEventParticipantsList } from '../../../../../../data/hooks/participant/useEventParticipantsList';
import { useMyUserId } from '../../../../../../data/hooks/sessionHooks';
import { useIdListFromQueryString } from '../../../../../../misc/useIdListFromQueryString';
import { useState } from 'react';

export function useInvitedParticipantsState(eventId, { rescheduleMeeting }) {
    const selfId = useMyUserId(),
        initialSelection = useEventParticipantsList(
            eventId,
            [
                ...useIdListFromQueryString('participants').map((id) => ({ participantId: id })),
                ...useIdListFromQueryString('users').map((id) => ({ userId: id })),
                ...(rescheduleMeeting?.invited.map((invitee) => ({ userId: invitee.user_id })) || []),
                { userId: rescheduleMeeting?.initiator.id },
            ],
            {
                filter: (p) => isParticipantUser(p) && p.user_id != selfId,
            }
        ).map((p) => p.user_id),
        [selection, setSelection] = useState(initialSelection);

    return [selection, setSelection];
}
